import { createFileRoute } from '@tanstack/react-router';
import { PageBody } from '@wundo/ui';
import { NotFoundPage } from '@/components/NotFoundPage.tsx';
import { PageTitle } from '@/components/PageTitle.tsx';
import { PracticeEditor } from '@/components/practice/PracticeEditor.tsx';
import { loadOrNotFound } from '@/lib/loadOrNotFound.ts';
import { roleplayDetailQuery } from '@/lib/roleplayDetailQuery.ts';
import { m } from '@/paraglide/messages.js';

export const Route = createFileRoute('/_app/practice/$roleplayId/edit')({
  loader: ({ context, params }) =>
    loadOrNotFound(() =>
      context.queryClient.ensureQueryData(roleplayDetailQuery(params.roleplayId)),
    ),
  /* Shown straight away, as the editor's own loading line was before the loader. */
  pendingComponent: EditPracticePending,
  pendingMs: 0,
  pendingMinMs: 0,
  notFoundComponent: NotFoundPage,
  component: EditPracticePage,
});

function EditPracticePending() {
  return (
    <>
      <PageTitle>{m.practice_form_edit_title()}</PageTitle>
      <PageBody>
        <p className='text-base text-ink-muted'>{m.practice_form_loading()}</p>
      </PageBody>
    </>
  );
}

/** Changing a practice conversation the organisation already has. */
function EditPracticePage() {
  const { roleplayId } = Route.useParams();

  return <PracticeEditor roleplayId={roleplayId} />;
}
